import { gql } from "@apollo/client";
export const GET_LOCATIONS = gql(`
  query Locations {
    locations {
      __typename
      id
      customFields {
        __typename
        id
        type
        name
      }
    }
  }
`);
